import { Box, Card, Flex, Heading, Text } from '@radix-ui/themes';
import { Link } from 'react-router-dom';
import type { CurrentPrice } from '@/types';
import { formatPrice, formatTimeRange } from '@/lib/utils';
import { PRICE_THRESHOLDS, PRICE_COLORS } from '@/config/priceThresholds';

interface PriceCardProps {
  price: CurrentPrice;
}

export function PriceCard({ price }: PriceCardProps) {
  const priceColor = getPriceColor(price.priceOreKwh);

  return (
    <Link to={`/${price.area.toLowerCase()}/latest`} style={{ textDecoration: 'none' }}>
      <Card
        size="3"
        style={{
          cursor: 'pointer',
          transition: 'transform 0.2s, box-shadow 0.2s',
        }}
        className="price-card"
      >
        <Flex direction="column" gap="2">
          <Flex justify="between" align="center">
            <Text size="2" color="gray" weight="medium">
              {price.area}
            </Text>
            <Text size="1" color="gray">
              {price.areaName}
            </Text>
          </Flex>

          <Box>
            <Heading size="7" style={{ color: priceColor }}>
              {formatPrice(price.priceOreKwh)}
            </Heading>
            <Text size="1" color="gray">
              öre/kWh
            </Text>
          </Box>

          {price.timeStart && price.timeEnd && (
            <Text size="1" color="gray">
              {formatTimeRange(price.timeStart, price.timeEnd)}
            </Text>
          )}
        </Flex>
      </Card>
    </Link>
  );
}

function getPriceColor(priceOre: number): string {
  if (priceOre < PRICE_THRESHOLDS.LOW) return PRICE_COLORS.LOW;
  if (priceOre < PRICE_THRESHOLDS.MEDIUM) return PRICE_COLORS.MEDIUM;
  if (priceOre < PRICE_THRESHOLDS.HIGH) return PRICE_COLORS.HIGH;
  return PRICE_COLORS.VERY_HIGH;
}
